import { render, staticRenderFns } from "./PerDraw.vue?vue&type=template&id=0aee0293&"
import script from "./PerDraw.vue?vue&type=script&lang=js&"
export * from "./PerDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports